import * as React from "react";

export abstract class BaseComponent<TProps, TState> extends React.Component<TProps, TState> {
    protected constructor(props: TProps) { super(props); }

    protected getStateField(field: keyof TState): any {
        return (this.state as any)[field];
    }

    protected setStateField(field: keyof TState, value: any): void {
        const newstate = {} as any;
        newstate[field] = value;
        this.setState(newstate);
    }
}


// WEBPACK FOOTER //
// ./Scripts/React/Component/BaseComponent.tsx